<template>
  <div class="tab-seven">
    <el-form class="form-wrapper">
      <el-form-item label="公司名称">
        <el-input
          v-model="local_filter_company_name"
          placeholder="请输入项目关键词"
        ></el-input>
      </el-form-item>
      <el-form-item label="应聘岗位">
        <el-select
          v-model="local_filter_company_work"
          multiple
          collapse-tags
          placeholder="请选择(支持多选)"
        >
          <el-option
            v-for="item in kCompanyWorkOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          v-model="local_filter_state"
          multiple
          collapse-tags
          placeholder="请选择(支持多选)"
        >
          <el-option
            v-for="item in kStateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div style="display: flex; flex-direction: column; align-items: center">
        <el-button @click="filterAction" size="small" type="primary"
        >筛选</el-button
        >
      </div>
    </el-form>
<!--    <p>-->
<!--      <el-button @click="bindEmailEmpower" v-if="bindInfo.email_empower" size="mini" type="primary">已授权验证码</el-button>-->
<!--      <el-button @click="bindEmailEmpower" v-if="!bindInfo.email_empower"  size="mini" type="info">未授权验证码</el-button>-->
<!--    </p>-->
    <el-alert title="" type="error">
      <template slot="title">
        <p>套辞公司:{{count.tc_count+count.tc_s_count}}位，海套公司:{{count.tc_count}}位，深套公司:{{count.tc_s_count}}位</p>
      </template>
    </el-alert>
    <el-table
      :data="lists"
      style="width: 100%"
      :default-sort="{ prop: 'company_name', order: 'descending' }"
      v-loading="loading"
    >
      <el-table-column center property="" fixed="left" label="编号" width="80px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="company_name" label="企业名称" sortable align="center" fixed="left" ></el-table-column>
      <el-table-column prop="company_work" label="应聘岗位" sortable align="center" width="150" />
      <el-table-column prop="email" label="Email" sortable align="center" ></el-table-column>
      <el-table-column prop="personal_homepage" label="公司网址" width="80" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.company_url">
            <el-link
              type="primary"
              :href="
                (scope.row.company_url || '').includes('http')
                  ? scope.row.company_url
                  : 'https://' + scope.row.company_url
              "
              target="_blank"
              >查看</el-link
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="90" align="center">
        <template slot-scope="scope">
          <el-popconfirm title="是否改为海套？" class="btn" @confirm="editStatus(scope.row.id,1)" v-if="scope.row.status == 2">
            <el-button slot="reference" size="mini" type="primary" style="background: #f85d66">企业深套</el-button>
          </el-popconfirm>
          <el-popconfirm title="是否改为深套？" class="btn" @confirm="editStatus(scope.row.id,2)" v-if="scope.row.status == 1" >
            <el-button slot="reference" size="mini" type="primary" style="background: #124fe8">企业海套</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column label="模板状态"  align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.email_template_status == 1" style="color: #08a0ee">模板初稿</div>
          <div v-else-if="scope.row.email_template_status == 2" style="color: #08a0ee">模板终稿</div>
          <div v-else-if="scope.row.email_template_status == 3" style="color: red">驳回</div>
          <div v-else-if="scope.row.email_template_status == 4" style="color: #08a0ee">同意</div>
          <div v-else style="color: red">还未生成模板</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        prop=""
        align="center"
        fixed="right"
        width="120"
      >
        <template slot-scope="scope">
          <div class="btns-wrapper">
            <el-button class="btn" v-if="scope.row.status == 1" size="mini" @click="showEmailDialog(scope.row,'c_tc')" type="primary">海套邮箱模板</el-button>
            <el-button class="btn" v-if="scope.row.status == 2" size="mini" @click="showEmailDialog(scope.row,'c_tcs')" type="primary">深套邮箱模板</el-button>
            <el-popconfirm
              title="是否确定删除？"
              class="btn"
              @confirm="delUserCompanyMagnets(scope.row.id)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
                :loading="delLoading"
                >删除</el-button
              >
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
<!--    <el-alert-->
<!--      v-if="showSchoolNoticeDialog"-->
<!--      style="margin-top: 2rem"-->
<!--      type="error">-->
<!--      <h3>企业套磁请知悉：</h3>-->
<!--      <p style="font-size: 1.2rem"> 当前还未添加企业套磁，请点击批量导入添加企业套磁</p>-->
<!--    </el-alert>-->
    <HBDoctorMagnetsEmail ref="doctor_magnets_email" @get_list="getList" />
    <el-dialog
        title="保存授权码"
        :visible.sync="openDialog"
        width="50%"
        center
        :append-to-body="true"
        :close-on-click-modal="false"
    >
      <el-form
          label-position="top"
          ref="teacherFrom"
          size="small"
          label-width="120px"
          style="margin: 0"
      >
        <el-form-item label="旧授权码" v-if="bindInfo.email_empower">
          <p>{{bindInfo.email_empower }}</p>
        </el-form-item>
        <el-form-item label="授权码">
          <template slot="label">
            授权码
            <el-tooltip>
              <div @click="checkEmpowerHelpe" slot="content">
                查看填写说明？点我点我（老师可见）
              </div>
              <i class="el-icon-info" />
            </el-tooltip>
          </template>
          <el-input type="text" v-model="email_empower"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button
              @click="openDialog = false"
              size="small"
              style="margin-right: 1rem"
          >取消</el-button
          >
          <el-button type="primary" size="small" @click="onSubmit()"
          >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

import {
  del_user_company_magnets,
  get_user_company_magnets,
  edit_user_company_magnets,
  email_empower_bind,
} from "@/api/mycenter_studyabroad.js";
import HBDoctorMagnetsEmail from "../HBCommon/HBEmailDialog/HBEmailDialog.vue";

export default {
  name: 'TabSevenTwo',
  components: {
    HBDoctorMagnetsEmail
  },
  data() {
    return {
      email_empower: '',
      openDialog: false,
      local_filter_company_name: undefined,
      local_filter_company_work: [],
      company_work_list: [],
      local_filter_state: [],

      is_assign_task_ps: '',
      is_assign_task_ps_list: [],
      loading: false,
      getShowSchoolNoticeText: '',
      delLoading: false,
      // showSchoolNoticeDialog: false,
      batchDialog: false,
      dataSource: [],
      infoDialogDataSource: [],
      count: {
        tc_count: 0,
        tc_s_count: 0
      },
      lists: [], // 数据列表
      requestData: {
        keywords: "", // 关键词
        page: 1, // 当前页
        paginate: 10000, // 分页大小
        templates_id: "",
        status: "",
        loading: "",
        user_id: "",
      },
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    editStatus(_id,_status){
      edit_user_company_magnets({ id: _id, status: _status,user_id: this.$route.query.userId })
        .then((response) => {
          this.$message.success('修改成功')
          this.getList(true);
        })
        .catch((error) => {
        });
    },
    bindEmailEmpower() {
      this.openDialog = true
    },
    onSubmit() {
      if (!this.email_empower) {
        this.$message.error('未填写授权码')
        return
      }
      email_empower_bind({ user_id: this.$route.query.userId,email_empower: this.email_empower }).then((response) => {
        this.$message.success('绑定成功')
        this.openDialog = false
        this.email_empower = ''
        this.$store.dispatch(
            'userAbroad/geUserAbroadData',
            parseInt(this.$route.query.userId)
        );
      })
    },
    showEmailDialog(_data,_type) {
      this.$refs.doctor_magnets_email.sendItem(_data, _type)
    },
    checkEmpowerHelpe() {
      window.open(
          "https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E823995081994177.pdf",
          "_blank"
      );
    },
    filterAction() {
      if (
        !this.local_filter_company_name &&
        (!this.local_filter_company_work || this.local_filter_company_work.length == 0) &&
        (!this.local_filter_state || this.local_filter_state.length == 0)) {
        // if (this.dataSource.length) {
        //   // this.showSchoolNoticeDialog = false
        // } else {
        //   this.getShowSchoolNotice()
        // }
        this.lists = this.dataSource;
        return
      }
      const resultList = [];
      const stateList = this.local_filter_state || [];
      const companyWorkList = this.local_filter_company_work || [];
      const company_name = this.local_filter_company_name || '';


      this.dataSource.forEach((item) => {
        var flag = true
        if (stateList.length > 0 && !stateList.includes(item.status)) {
          flag = false
        }
        if (companyWorkList.length > 0 && !companyWorkList.includes(item.company_work)) {
          flag = false
        }
        if (
          company_name &&
          !item.company_name
            .toLocaleLowerCase()
            .includes(company_name.toLocaleLowerCase())
        ) {
          flag = false;
        }
        if (flag == true) {
          resultList.push(item)
        }
      })
      if (resultList.length) {
        this.showSchoolNoticeDialog = false
      } else {
        // this.getShowSchoolNotice()
      }
      this.lists = resultList
    },
    infoHbtitle() {
      return '套磁'
    },
    // getShowSchoolNotice(){
    //   this.getShowSchoolNoticeText  = '3：当前学生还没有申请方向；请在申请信息中修改';
    //   if(this.$store.state.userAbroad.userAbroadBindData.apply_direction){
    //     this.getShowSchoolNoticeText  = '3：当前学生的申请方向为：'+this.$store.state.userAbroad.userAbroadBindData.apply_direction+'；如需修改，请在申请信息中修改';
    //   }
    //   this.showSchoolNoticeDialog = true
    // },
    getList(isRefresh) {
      // 获取列表
      if (isRefresh) {
        this.requestData.page = 1;
      }
      this.requestData.user_id = this.$route.query.userId;
      this.loading = true;
      get_user_company_magnets(this.requestData).then((response) => {
        this.loading = false;
        const dataList = response.data || []
        this.dataSource = dataList.list
        this.lists = dataList.list
        this.count = dataList.count
        this.filterAction()
      }).catch(error => {
        this.loading = false
        this.$message.error(error.message)
      });
    },
    delUserCompanyMagnets(id) {
      this.delLoading = true;
      del_user_company_magnets({ id: id, user_id: this.$route.query.userId })
        .then((response) => {
          this.$message.success("删除成功");
          this.getList(true);
          this.delLoading = false;
        })
        .catch((error) => {
          this.delLoading = false;
        });
    },

    batchImportChooseUpdate() {
      this.batchDialog = false;
      this.getList();
    },
  },
  computed: {
    bindInfo() {
      return this.$store.state.userAbroad.userAbroadData;
    },
    kCompanyWorkOptions() {
      if (this.dataSource && this.dataSource.length > 0) {
        const l = [];
        this.dataSource.forEach((item) => {
          const index = l.findIndex(
            (subItme) => subItme.label == item.company_work
          );
          if (index < 0) {
            l.push({
              label: item.company_work,
              value: item.company_work
            });
          }
        });
        return l;
      } else {
        return [];
      }
    },
    kEmailStateOptions() {
      return [
        {
          label: "待确认",
          value: 2,
        },
        {
          label: "驳回",
          value: 3,
        },
        {
          label: "同意",
          value: 4,
        },
      ];
    },
    kStateOptions() {
      return [
        {
          label: "未选择",
          value: 0,
        },
        {
          label: "公司海套",
          value: 1,
        },
        {
          label: "公司深套",
          value: 2,
        },
      ];
    }

  },
};
</script>
<style lang="scss" scoped>
.hidden_content{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 显示行数 */
  overflow: hidden;
  white-space: normal;
}
.tab-seven {
  .form-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }

  .max-two-line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .btn {
      margin-bottom: 5px;
      margin-left: 0 !important;
    }
  }
  .complete {
    color: #67c23a;
  }
  .danger {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_seven_three.vue